import BookingPriceItem from './BookingPriceItem';
export default BookingPriceItem;
